import { Box, Typography } from "@mui/material";
import { User } from "User/entity";

export const AccountDetails = ({ user }: { user: User }) => {
  return (
    <Box sx={{ p: 2, pb: 1.5 }}>
      <Typography noWrap variant="subtitle2">
        {user.name}
      </Typography>

      {/* <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
        {user?.email}
      </Typography> */}
    </Box>
  );
};
